import React, { Fragment } from 'react'
import {
    List,
    Datagrid,
    NumberField,
    TextField,
    EmailField,
    SelectField,
    BooleanField
} from 'react-admin'

import Title from '../Generic/Title'

import { rolesChoices } from './data.js'

export const UsuarioList = ({ permissions, ...props }) => {
    if (permissions === null) {
        return null
    }
    const role = permissions.role
    return (
        <Fragment>
            <Title title={"Usuarios Coordinador"} />
            <List {...props} exporter={false} >
                <Datagrid rowClick="edit">
                    <NumberField source="id" />
                    <TextField source="first_name" label="Nombre"/>
                    <TextField source="last_name" label="Apellido"/>
                    <TextField source="username" label="Nombre de Usuario"/>
                    <EmailField source="email" />
                    { role === "coordinado"
                        ? null
                        : (
                            <SelectField
                                source="role"
                                label="Rol"
                                choices={rolesChoices}
                            />
                        )
                    }
                    <BooleanField source="is_active" label="Estado"/>
                </Datagrid>
            </List>
        </Fragment>
    )
}
